import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

import { SHAREDCONSTANTS } from '../_constants/constants';
import { NotificationDialogComponent } from '../notification/notification.dialog.component';

export class AgentProfile {
    firstname: string;
    surname: string;
    phone: string;
    email: string;
    locked: boolean;
    deleted: boolean;
    unsuspended: boolean;
    passwordExpirationWarn: boolean;
    tokenUsed: boolean;
    tokenExpired: boolean;
    corpDirUser: boolean;
    vfuid: string;
    accountId
    activeEntry: boolean;
    company: string;
    department: string;
    internal: boolean;
    permissions: { [opco: string]: string[] };    
    countries: { [country:string] : string[]};
    originalPermissions: { [opco: string]: string[] };

    permissionError:string;
    lastSuccessFulLoginDetail: string;
    currentLoginDateAndTime: string;
    aaaMyAccountUrl: string;
    supportedSearchParameter : {[opco: string]: string[]};
              

    constructor(agentprofile: AgentProfile) {
        if (agentprofile) {

            let tempCountryValues = []; 
            let tempCountries:any = {};  
            let tempPermissions:any = {}; 

            let mockPermissions1 = {"nv-nz":["view","kyc.write","edit","delete"],"nv":["view","kyc.write","edit","delete"],"nv-hu":["view","kyc.write","edit","delete"],"cz":["view","kyc.write","edit","delete"],"ro":["view","kyc.write","edit","delete"],"nl":["view","kyc.write","edit","delete"]}            
            let mockPermissions2 = {"nv-nz":["view","kyc.write","edit","delete"],"nv-hu":["view","kyc.write","edit","delete"], "nv-de":["view","kyc.write","edit","delete"]};
            let mockPermissions3 = {"cz":["view","kyc.write","edit","delete"], "nv-nz":["view","kyc.write","edit","delete"],"nl":["view","kyc.write","edit","delete"],"nv-hu":["view","kyc.write","edit","delete"]};
            let mockPermissions4 = {"cz":["view","kyc.write","edit","delete"], "nl":["view","kyc.write","edit","delete"], "nv":["view","kyc.write","edit","delete"]};
            let mockPermissions5 = {"nv-nz":["view","kyc.write","edit","delete"],"nv-hu":["view","kyc.write","edit","delete"], "nl-au":["view","kyc.write","edit","delete"],"nl-de":["view","kyc.write","edit","delete"]};
            let mockPermissions6 = {"nv-nz":["view","kyc.write","edit","delete"],"nv-hu":["view","kyc.write","edit","delete"], "nl-au":["view","kyc.write","edit","delete"],"nl-de":["view","kyc.write","edit","delete"], "al":["view","kyc.write","edit","delete"]};
            let mockPermissions7 = {"cz":["view","kyc.write","edit","delete"], "nv-nz":["view","kyc.write","edit","delete"],"nl":["view","kyc.write","edit","delete"],"nv-de":["view","kyc.write","edit","delete"],"nl-hu":["view","kyc.write","edit","delete"]};
            let mockPermissions8 = {"al":["view","kyc.write","edit","delete"], "nl":["view","kyc.write","edit","delete"]};
            let mockPermissions9 = { "nv-de": ["view", "kyc.write", "edit", "delete"] };

            //agentprofile.permissions = mockPermissions9;            

            for(var key in agentprofile.permissions) {
                if (agentprofile.permissions.hasOwnProperty(key)) {
                    if(key.indexOf("-")!== -1){                        

                        tempCountryValues.push(key);
                        var opcoCountryMap = key.split('-');                          
                        tempCountries[opcoCountryMap[0]] = [];               
                    }
                    else{                                             
                        tempPermissions[key] = agentprofile.permissions[key];
                    }                    
                }
            }
        
            if(tempCountryValues.length){

                tempCountryValues.forEach(function (item, index) {                    

                    var opcoCountry = item.split('-');
                    var opco = opcoCountry[0];
                    var market = opcoCountry[1];

                    if(tempCountries && tempCountries.hasOwnProperty(opco)){
                        tempCountries[opco].push(market);                        
                    }                    
                });
            } 

            if(Object.keys(tempPermissions).length === 0 && Object.keys(tempCountries).length === 1){
                tempPermissions = tempCountries;
            }
            else if(Object.keys(tempCountries).length > 0){

                for(var obj in tempCountries){                    
                    tempPermissions[obj] = tempCountries[obj];
                }
            }            
                           

            this.firstname = agentprofile.firstname;
            this.surname = agentprofile.surname;
            this.phone = agentprofile.phone;
            this.email = agentprofile.email;
            this.locked = agentprofile.locked;
            this.deleted = agentprofile.deleted;
            this.unsuspended = agentprofile.unsuspended;
            this.passwordExpirationWarn = agentprofile.passwordExpirationWarn;
            this.tokenUsed = agentprofile.tokenUsed;
            this.tokenExpired = agentprofile.tokenExpired;
            this.corpDirUser = agentprofile.corpDirUser;
            this.vfuid = agentprofile.vfuid;
            this.accountId = agentprofile.accountId;
            this.activeEntry = agentprofile.activeEntry;
            this.company = agentprofile.company;
            this.department = agentprofile.department;
            this.internal = agentprofile.internal;

            this.permissions = tempPermissions;
            this.countries = tempCountries;            

            this.originalPermissions = agentprofile.permissions;
            this.lastSuccessFulLoginDetail = ((agentprofile.lastSuccessFulLoginDetail === null) || (!agentprofile.lastSuccessFulLoginDetail) || (agentprofile.lastSuccessFulLoginDetail === undefined)) ? agentprofile.currentLoginDateAndTime : agentprofile.lastSuccessFulLoginDetail;                  
            this.aaaMyAccountUrl = (agentprofile.aaaMyAccountUrl !== null && agentprofile.aaaMyAccountUrl !== "" && typeof agentprofile.aaaMyAccountUrl !== "undefined") ? agentprofile.aaaMyAccountUrl : SHAREDCONSTANTS["USERSESSIONVIEWLABELS"].MY_ACCOUNT_LINK;
            this.supportedSearchParameter = agentprofile.supportedSearchParameter;

        } else {
            this.firstname = '';
            this.surname = '';
            this.permissions = {};
        }
    }


    isAllowedToEdit(opco: string, selectedCountry?:string) {
        if (!this.originalPermissions || Object.keys(this.originalPermissions).length < 1) {
            return false;
        }
        if(selectedCountry !== undefined && opco!==""){
            if (this.originalPermissions[opco+"-"+selectedCountry].indexOf(SHAREDCONSTANTS.ACTION_Edit) >= 0) {
                return true;
            }
        }
        else{
            if (this.originalPermissions[opco].indexOf(SHAREDCONSTANTS.ACTION_Edit) >= 0) {
                return true;
            }
        }        
        return false;
    }

    isAllowedToKYCEdit(opco: string, selectedCountry?:string) {
        if (!this.originalPermissions || Object.keys(this.originalPermissions).length < 1) {
            return false;
        }
        if(selectedCountry !== undefined && opco!==""){
            if (this.originalPermissions[opco+"-"+selectedCountry].indexOf(SHAREDCONSTANTS.ACTION_KYC_Edit) >= 0) {
                return true;
            }
        }
        else{
            if (this.originalPermissions[opco].indexOf(SHAREDCONSTANTS.ACTION_KYC_Edit) >= 0) {
                return true;
            }
        }        
        return false;
    }

    isAllowedToDelete(opco: string, selectedCountry?:string) {
        if (!this.originalPermissions || Object.keys(this.originalPermissions).length < 1) {
            return false;
        }
        if(selectedCountry !== undefined && opco!==""){
            if (this.originalPermissions[opco+"-"+selectedCountry].indexOf(SHAREDCONSTANTS.ACTION_Delete) >= 0) {
                return true;
            }
        }
        else{
            if (this.originalPermissions[opco].indexOf(SHAREDCONSTANTS.ACTION_Delete) >= 0) {
                return true;
            }
        }        
        return false;
    }
    // isAllowedToView(opco: string) {
    //     if (!this.permissions || Object.keys(this.permissions).length < 1) {
    //         return false;
    //     }

    //     if (this.permissions[opco].indexOf(SHAREDCONSTANTS.ACTION_View) >= 0) {
    //         return true;
    //     }
    //     return false;
    // }
    isAllowedToView(opco: string) {
        if (!this.originalPermissions || Object.keys(this.originalPermissions).length < 1) {
            return false;
        }

        if (this.originalPermissions[opco] && this.originalPermissions[opco].indexOf(SHAREDCONSTANTS.ACTION_View) >= 0) {
            return true;
        }
        return false;
    }

    checkAndReactForOpco(opco: string, router: Router, ds: DialogService, selectedCountry?:string): boolean {
        
        let opcofound = false;
        let selectedOpco = (selectedCountry !== undefined  && opco!="") ? opco+"-"+selectedCountry : opco;
        
        for (const cp in this.originalPermissions) {
            if (selectedOpco.toLowerCase() === cp.toLowerCase()) {
                opcofound = true;
                break;
            }
        }
        if (!opcofound) {

            // let invalid_opco_erro = localStorage.getItem("invalid_opco_erro"); 

            // if (invalid_opco_erro == "" || !invalid_opco_erro || invalid_opco_erro == null || invalid_opco_erro == undefined) {
            //     localStorage.setItem("invalid_opco_erro", "true");
            // }
                                
            //console.log("No valid Opco given.")            
                        
            setTimeout(() => {
                ds.addDialog(NotificationDialogComponent, {
                    success: false,
                    message: this.permissionError
                });                               
            },500);  

            router.navigate(['/']);

                    
                     
            return;            
        }
        return true;
    }

    checkAndReactActionView(opco: string, router: Router, ds: DialogService, route:ActivatedRoute, selectedCountry?:string): boolean {

        let activatedRoute = route;
        let selectedOpco = opco;

        activatedRoute.params.subscribe(params => {
            let selectedCountry = params['country'];
            let opcoValue = params['opco'];
             
            if(selectedCountry && opcoValue) {
                selectedOpco = opcoValue+"-"+selectedCountry;                         
            }
        });

        if (!this.isAllowedToView(selectedOpco)) {

            //console.log("No View-Permission given."); 

            setTimeout(() => {
                ds.addDialog(NotificationDialogComponent, {
                    success: false,
                    message: this.permissionError
                });
            });            

            router.navigate(['/']);                        
        }
        return true;
    }

    getAvailableOpcos(): string[] {
        if (this.permissions) {
            let allCountries = Object.keys(this.permissions).sort();            
            allCountries.unshift("Select Country");
            return allCountries;
            //return Object.keys(this.permissions).sort();
        }
        return [];
    }

    getAvailableOpcosValue(): string[] {
        if (this.permissions) {
            
            return Object.keys(this.permissions).sort();
        }
        return [];
    }


    getSelectedOpco(): string {
        return "al";
    }


    getAvailableCountries(selectedOpco): string[] {

        // if (this.countries.hasOwnProperty(selectedOpco)) {
        //     return this.countries[selectedOpco].sort();
        // }
        // return [];

        if(selectedOpco === "" && Object.keys(this.countries).length === 1){            
            return this.countries[Object.keys(this.countries)[0]].sort();
        }
        if(selectedOpco === "" && Object.keys(this.countries).length > 1){              
            if(this.countries[Object.keys(this.permissions).sort()[0]] !== undefined ){
                return this.countries[Object.keys(this.permissions).sort()[0]];
            } 
            return [];           
        }
        else{
            if (this.countries.hasOwnProperty(selectedOpco)) {
                return this.countries[selectedOpco].sort();
            }
            return [];
        }                
    }


    getDefaultAvailableCountries(): boolean {        

        if(this.countries[Object.keys(this.permissions).sort()[0]] !== undefined){
            return true;
        }
        return false;                        
    }
}

export class AgentProfileLastLogin{
    datetime: string;
    status: string;

    constructor(agentprofilelastlogin: AgentProfileLastLogin) {
        if (agentprofilelastlogin) {
            this.datetime = agentprofilelastlogin.datetime;
            this.status = agentprofilelastlogin.status;
        }else{
            this.datetime = '';
            this.status = '';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/_models/agent.profile.ts